export default {
    tumor_stage: [
      { value: 1001, label: "StageIII&IV", color: "#009900", show: true },
      { value: 1002, label: "StageI&II", color: "#C0C0C0", show: true },
    ],
    // response: [
    //   // { value: 2001, label: "discovery", color: "#1E88E5", show: true },
    //   { value: 2001, label: "R", color: "#0000FF", show: true },
    //   { value: 2002, label: "NR", color: "#FF0000", show: true },
    //   { value: 2003, label: "NaN", color: "#000000", show: true },
    // ],
    // cohort: [
    //   { value: 1001, label: "discovery", color: "#FF0000", show: true },
    //   { value: 1002, label: "validation", color: "#00FF00", show: true },
    // ],
    tissue_level: [
      { value: 19001, label: "Primary", color: "#0000FF", show: true },
      { value: 19002, label: "Metastasis", color: "#FF0000", show: true },
    ],
    Death: [
      { value: 20001, label: 'alive', color: "#C0C0C0", show: true },
      { value: 20002, label: 'death', color: "#FF0000", show: true },
    ],
    'Death or Progression': [
      { value: 21001, label: 'alive without progression', color: "#C0C0C0", show: true },
      { value: 21002, label: 'death/progression', color: "#FF0000", show: true },
    ],
    'Radiation-therapy': [
      { value: 22002, label: 'Yes', color: "#005effff", show: true },
      { value: 22001, label: 'No', color: "#C0C0C0", show: true },
    ],
    'Chemo-therapy': [
      { value: 23002, label: 'Yes', color: "#005effff", show: true },
      { value: 23001, label: 'No', color: "#C0C0C0", show: true },
    ],
    'Immuno-therapy': [
      { value: 24002, label: 'Yes', color: "#005effff", show: true },
      { value: 24001, label: 'No', color: "#C0C0C0", show: true },
    ],
    'Targeted-therapy': [
      { value: 25002, label: 'Yes', color: "#005effff", show: true },
      { value: 25001, label: 'No', color: "#C0C0C0", show: true },
    ],
    'BRAF_hotspot' :[
      { value: 26001, label: 'V600E', color: "#D81B60", show: true },
      { value: 26002, label: 'V600K', color: "#1E88E5", show: true },
      { value: 26003, label: 'V600R', color: "#FFC107", show: true },
      { value: 26004, label: 'non-hotspot mutation', color: "#004D40", show: true },
      { value: 26005, label: 'no mutation', color: "#C0C0C0", show: true },
    ],
     'NRAS_hotspot' :[
      { value: 27001, label: 'Q61', color: "#D81B60", show: true },
      { value: 27002, label: 'Q63', color: "#1E88E5", show: true },
      // { value: 26003, label: 'V600R', color: "#FFC107", show: true },
      { value: 27003, label: 'non-hotspot mutation', color: "#004D40", show: true },
      { value: 27004, label: 'no mutation', color: "#C0C0C0", show: true },
    ],
    'KRAS_hotspot' :[
      { value: 27001, label: 'Q61', color: "#D81B60", show: true },
      // { value: 27002, label: 'Q63', color: "#1E88E5", show: true },
      // { value: 26003, label: 'V600R', color: "#FFC107", show: true },
      { value: 27003, label: 'non-hotspot mutation', color: "#004D40", show: true },
      { value: 27004, label: 'no mutation', color: "#C0C0C0", show: true },
    ],
    'transcriptional_state_classification' :[
      { value: 28001, label: 'malignant_M', color: "#D81B60", show: true },
      { value: 28002, label: 'malignant_T', color: "#1E88E5", show: true },
      { value: 28003, label: 'malignant_AP1', color: "#FFC107", show: true },
      { value: 28004, label: 'non-malignant_AP2', color: "#004D40", show: true },
    ],
    'SNF_group_of_interest' :[
      { value: 26001, label: 'prim_pmel', color: "#D81B60", show: true },
      { value: 26002, label: 'met_axl', color: "#1E88E5", show: true },
      { value: 26003, label: 'met_pmel', color: "#FFC107", show: true },
      { value: 26004, label: 'other', color: "#004D40", show: true },
    ],
     'ubi_cluster' :[
      // { value: 29001, label: 'c1', color: "#D81B60", show: true },
      { value: 29002, label: 'Baseline', color: "#1E88E5", show: true },
      { value: 29003, label: 'IFN-UB', color: "#FFC107", show: true },
      // { value: 28004, label: 'non-malignant_AP2', color: "#004D40", show: true },
    ],
    // tumorClass: [
    //   { value: 3001, label: "ccRCC", color: "#29ECEA", show: true },
    //   { value: 3002, label: "AML", color: "#F7CBAD", show: true },
    //   { value: 3003, label: "BHD", color: "#F3B084", show: true },
    //   { value: 3004, label: "ChRCC", color: "#CB93FF", show: true },
    //   { value: 3005, label: "ESCRCC", color: "#BE9004", show: true },
    //   { value: 3006, label: "MEST", color: "#005A9C", show: true },
    //   { value: 3007, label: "MTOR Mutated RCC", color: "#C45613", show: true },
    //   { value: 3008, label: "MTSCC-variant", color: "#FEC108", show: true },
    //   { value: 3009, label: "ND", color: "#056608", show: true },
    //   { value: 3010, label: "Oncocytoma type1", color: "#FEC9FF", show: true },
    //   { value: 3011, label: "Oncocytoma type2", color: "#FD91FF", show: true },
    //   { value: 3012, label: "Oncocytoma variant", color: "#FC53FF", show: true },
    //   { value: 3013, label: "PRCC", color: "#F7FB9F", show: true },
    //   { value: 3014, label: "PRCC type1", color: "#FFFF0B", show: true },
    //   { value: 3015, label: "PUC", color: "#4A0D4B", show: true },
    //   { value: 3016, label: "TRCC", color: "#FFE799", show: true },
    //   { value: 3017, label: "unRCC", color: "#DC143C", show: true },
    // ],
    age_group: [
      { value: 4001, label: "<59.0 (25%)", color: "#EEEEEE", show: true },
      { value: 4002, label: "59.0-69.5 (25%-50%)", color: "#CCBBAA", show: true },
      { value: 4003, label: "69.5-76.0 (50%-75%)", color: "#997755", show: true },
      { value: 4004, label: ">76.0 (>75%)", color: "#663300", show: true },
    ],
    sex: [
        { value: 5001, label: "Female", color: "#FF82AB", show: true },
        { value: 5002, label: "Male", color: "#008B00", show: true },
    ],
     ARID1A: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    ARID2: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
     ATRX: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    BRAF: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
     TERT: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    NRAS: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    NF1: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],

     TP53: [
      { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
      { value: 18003, label: "mutant", color: "#660033", show: true },
      { value: null, label: "", color: "#ebebeb", show: true },
    ],
    ICI_cluster: [
      { value: 32001, label: "EMT-like", color: "#D81B60", show: true },
      { value: 32002, label: "ICI-sensitive", color: "#1E88E5", show: true },
      { value: 32003, label: "Ribo-high", color: "#FFC107", show: true },
    ],
    'glyco cluster': [
      { value: 34001, label: "Lysosome high", color: "#D81B60", show: true },
      { value: 34002, label: "Other", color: "#1E88E5", show: true },
      // { value: 34003, label: "Ribo-high", color: "#FFC107", show: true },
    ],
    // ethnicity: [
    //   { value: 6001, label: "Caucasian", color: "#FF33FF", show: true },
    //   {
    //     value: 6002,
    //     label: "non-Caucasian",
    //     color: "#30FF3E",
    //     show: true,
    //   },
    //   { value: 6005, label: "Hispanic", color: "#00BFFF", show: true },
    //   { value: 6004, label: "African-American", color: "purple", show: true },
    // ],
    // "AJCC Stage": [
    //   { value: 7001, label: "AJCC III (includes B/C/D)", color: "#C0C0C0", show: true },
    //   { value: 7002, label: "AJCC IV-A", color: "#FF8000", show: true },
    //   { value: 7003, label: "AJCC IV-B", color: "#FF007F", show: true },
    //   { value: 7004, label: "AJCC IV-C", color: "#FF0000", show: true },
    //   { value: 7005, label: "AJCC IV-D", color: "#009900", show: true },
    // ],
    // Biopsy_site_tissue: [
    //   { value: 8001, label: "skin", color: "#8B4513", show: true },
    //   { value: 8002, label: "lung", color: "#FFB90F", show: true },
    //   { value: 8003, label: "LN", color: "#FF00FF", show: true },
    // ],
    // 'Progression-free survival event': [
    //   { value: 9001, label: "Y", color: "#000000", show: true },
    //   { value: 9002, label: "N", color: "#EEEEEE", show: true },
    // ],
    // 'Progression-free survival days': [
    //   { value: 10003, label: "<103 days (25%)", color: "#EEEEEE", show: true },
    //   { value: 10001, label: "103-302 days (25%-50%)", color: "#DDAAAA", show: true },
    //   { value: 10002, label: "302-1583 days (50%-75%)", color: "#BB5555", show: true },
    //   { value: 10004, label: ">1583 days (>75%)", color: "#990000", show: true },
    // ],
    // "FFPE Sample Type": [
    //   { value: 11003, label: "slides", color: "#0080FF", show: true },
    //   {
    //     value: 11001,
    //     label: "gross dissection",
    //     color: "#660066",
    //     show: true,
    //   },
    //   {
    //     value: 11002,
    //     label: "punch",
    //     color: "#66CC00",
    //     show: true,
    //   },
    //   // { value: 11004, label: ">=104.5 (>75%)", color: "#1B4332", show: true },
    // ],
    // 'Protein Subtype': [
    //   { value: 19001, label: "Subtype 1", color: "#D81B60", show: true },
    //   { value: 19002, label: "Subtype 2", color: "#1E88E5", show: true },
    //   { value: 19003, label: "Subtype 3", color: "#FFC107", show: true },
    // ],
    // Study_Site: [
    //   { value: 12010, label: "GE", color: "#4C9900", show: true },
    //   { value: 12001, label: "MIA", color: "#CCCC00", show: true },
    //   { value: 12002, label: "MDACC", color: "#00CC66", show: true },
    //   { value: 12003, label: "MGH", color: "#0066CC", show: true },
    //   { value: 12004, label: "MSK", color: "#009999", show: true },
    //   { value: 12005, label: "NY", color: "#00NY00", show: true },
    //   { value: 12006, label: "POL", color: "#CC0066", show: true },
    //   { value: 12007, label: "UM", color: "#00CC66", show: true },
    //   { value: 12008, label: "UPENN", color: "#990099", show: true },
    //   { value: 12009, label: "UPITT", color: "#663300", show: true },
    //   { value: 12010, label: "VAND", color: "#330033", show: true },
    //   { value: 12011, label: "YALE", color: "#660000", show: true },
    //     // { value: 12012, label: "YALE", color: "#660000", show: true },
    // ],
    // TERT: [
    //   { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
    //   { value: 18003, label: "mutant", color: "#660033", show: true },
    //   { value: null, label: "", color: "#ebebeb", show: true },
    // ],
    // BRAF: [
    //   { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
    //   { value: 18003, label: "mutant", color: "#660033", show: true },
    //   { value: null, label: "", color: "#ebebeb", show: true },
    // ],
    // NRAS: [
    //   { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
    //   { value: 18003, label: "mutant", color: "#660033", show: true },
    //   { value: null, label: "", color: "#ebebeb", show: true },
    // ],
    // NF1: [
    //   { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
    //   { value: 18003, label: "mutant", color: "#660033", show: true },
    //   { value: null, label: "", color: "#ebebeb", show: true },
    // ],
    // ARID2: [
    //   { value: 18002, label: "wildtype", color: "#ebebeb", show: true },
    //   { value: 18003, label: "mutant", color: "#660033", show: true },
    //   { value: null, label: "", color: "#ebebeb", show: true },
    // ],
  };
  